<script setup lang="ts">
import Modal from '@ui/modal/Modal.vue';
import Toastr from '@ui/toastr/Toastr.vue';
</script>
<template>
    <Toastr />
    <Modal />
    <RouterView />
</template>
